module.exports = __webpack_public_path__ + "img/eoimage.fd695878.jpg";